import { extendsSchema } from '@/CommonDP/VForm/utils';
import { baseSchema } from './utils';
export const schema = extendsSchema({
  label: '人员列表',
  component: require('./index.vue').default,
  options: {
    max: 100,
    min: 0,
    assignToId: '',
    assignToName: '',
    assignToUserName: ''
  },
  setDesign: {
    userKeys: (item) => (item.options.name)
  }
}, baseSchema);
// 单人选择 关联值为 人员id:string,需要调用接口获取详细数据
export const singleSchema = extendsSchema(
  {
    type: 'jy-user-single',
    icon: 'radio-field',
    label: '人员',
    options: {
      single: true,
      label: '人员选择',
      assignToName: '',
      assignToUserName: ''
    },
    component: require('./single.vue').default
  },
  baseSchema
);
